import { useState } from "react";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import Sidebar from "./Sidebar";

export default function MobileTopbar({ activeDoctor }: { activeDoctor?: any }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Topbar minimale — visible < lg uniquement, classe "topbar" pour mobile-chat-mode */}
      <header className="topbar lg:hidden flex items-center justify-between px-4 py-3 bg-white border-b border-slate-200/80 shadow-[0_1px_3px_0_rgb(0,0,0,0.06)] shrink-0">
        <span className="text-lg font-bold text-primary tracking-tight">Back Office</span>
        <button
          onClick={() => setOpen(true)}
          className="p-2 rounded-lg hover:bg-slate-100 text-slate-600 transition-colors"
          aria-label="Open navigation"
        >
          <Menu className="w-5 h-5" />
        </button>
      </header>

      {/* Drawer hamburger */}
      <AnimatePresence>
        {open && (
          <>
            {/* Overlay */}
            <motion.div
              key="overlay"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="fixed inset-0 bg-black/40 z-40 lg:hidden"
              onClick={() => setOpen(false)}
            />

            {/* Panel sidebar */}
            <motion.div
              key="drawer"
              initial={{ x: -240 }}
              animate={{ x: 0 }}
              exit={{ x: -240 }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              className="fixed inset-y-0 left-0 z-50 lg:hidden flex"
            >
              <div className="relative flex flex-col w-60 h-full bg-white shadow-xl">
                {/* Bouton fermeture */}
                <button
                  onClick={() => setOpen(false)}
                  className="absolute top-4 right-3 p-1.5 rounded-md hover:bg-slate-100 text-slate-500 z-10"
                  aria-label="Close navigation"
                >
                  <X className="w-4 h-4" />
                </button>

                {/* Sidebar en mode mobile (pas de hidden lg:flex) */}
                <Sidebar
                  activeDoctor={activeDoctor}
                  onClose={() => setOpen(false)}
                  variant="mobile"
                />
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
}
